import React from 'react';
import styled from "@emotion/styled";
import { Inner, gridColumns } from 'styles/structure';
import colors from "styles/colors";
import dimensions from 'styles/dimensions';
import { Rubric } from 'styles/typography';
import CardComparison from './CardComparison';
/*import Content from 'components/_ui/Content';*/

const AudienceComparisonContainer = styled.div`
  background-color: ${colors.orange100};
  padding: 5.6rem 0;
  
  & + * {
    margin-top: 6.4rem;
  }
  
  @media(min-width: ${dimensions.tabletLandscapeUp}px) {
    padding: 7.2rem 0;
    
    & + * {
      margin-top: 12rem;
    }
`;

const ComparisonHeader = styled.header`
  text-align: center;
  margin-bottom: 6.4rem;
`;

const ComparisonPricing = styled.ul`
  margin-top: 4rem;
  
  li {
    text-align: center;
    
    & + * {
      margin-top: 3.2rem;
    }
  }
  
  p {
    margin-top: 0.6rem;
    font-size: 1.4rem;
  }
  
  @media(min-width: ${dimensions.tabletLandscapeUp}px) {
    display: flex;
    width: 100%;
    
    li {
      flex: 0 0 33.3334%;
      padding: 0 1.6rem;
      
      & + * {
        margin-top: 0;
      }
    }
    
    p {
      max-width: 20rem;
      margin-left: auto;
      margin-right: auto;
    }
  }
`;

const ComparisonProducts = styled.ul`
  margin-top: 6.4rem;

  > li {
    max-width: 42.4rem;
    margin-left: auto;
    margin-right: auto;
    
    & + * {
      margin-top: 1.6rem;
    } 
  }
  
  @media(min-width: ${dimensions.tabletLandscapeUp}px) {
    display: flex;
    flex-wrap: wrap;
    
    > li {
      ${gridColumns('1/2', 3.2)};
      
      max-width: none;
      display: flex;
      justify-content: stretch;
      
      & + * {
        margin-top: 0;
      } 
      
      &:nth-of-type(n+3) {
        margin-top: 1.6rem;
      }
    }
  }
  
  @media(min-width: ${dimensions.desktopUp}px) {
    > li {
      ${gridColumns('1/3', 1.6)};
      
      &:nth-of-type(n+3) {
        margin-top: 0;
      }
    }
    
    &.ComparisonProducts--dense {
      > li {
        ${gridColumns('1/4', 1.6)};
      }
    } 
  }
`;

const AudienceComparison = ({ rubric, facts, plans, products }) => {
  return (
    <AudienceComparisonContainer>
      <Inner>
        <ComparisonHeader>
          {rubric && (
            <Rubric>{rubric}</Rubric>
          )}

          {(facts && facts.length > 0 && facts[0].heading) && (
            <ComparisonPricing>
              {facts.slice(0,3).map((fact, i) => (
                <li key={i}>
                  <h4>{fact.heading}</h4>
                  <p>{fact.text}</p>
                </li>
              ))}
            </ComparisonPricing>
          )}
        </ComparisonHeader>

        <ComparisonProducts className={((plans && plans.length > 3) || (products && products.length > 3)) ? 'ComparisonProducts--dense' : ''}>
          {plans && plans.slice(0,4).map(({plan}, i) => (
            <li key={i}>
              <CardComparison
                plan={plan}
              />
            </li>
          ))}

          {products && products.slice(0,4).map((product, i) => (
            <li key={i}>
              <CardComparison
                product={product.product}
                destination={product.cta_destination}
              />
            </li>
          ))}
        </ComparisonProducts>
      </Inner>
    </AudienceComparisonContainer>
  );
};

export default AudienceComparison;
